<template>
  <RevContainer class="py-32">
    <section class="flex flex-col items-center gap-24 md:flex-row md:gap-48">
      <div class="flex w-full flex-col gap-24 md:w-1/2">
        <header class="flex flex-col gap-8">
          <h1 class="heading-1 whitespace-pre-line">
            {{ i18n(translations.heading, { status }) }}
          </h1>
          <p>
            {{ i18n(translations.firstParagraph) }}
          </p>
        </header>

        <p>{{ i18n(translations.secondParagraph) }}</p>
      </div>

      <RevIllustration
        alt=""
        class="w-full md:w-1/2"
        :height="170"
        src="/img/phone-in-grass.png"
        :width="327"
      />
    </section>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './GenericError.translations'

const i18n = useI18n()

defineProps<{
  status: number
}>()
</script>
